module.exports = __webpack_public_path__ + "img/pc_01.74e3b75e.png";